import { render, staticRenderFns } from "./BannersFilters.vue?vue&type=template&id=78167f6e&"
import script from "./BannersFilters.vue?vue&type=script&lang=js&"
export * from "./BannersFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports